"use client";

import { useRouterState } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

export const PostHogPageView = () => {
    const posthog = usePostHog();
    const location = useRouterState({ select: (s) => s.location });

    useEffect(() => {
        posthog.capture("$pageview", {
            $current_url: window.location.href,
        });
    }, [location.pathname, location.search, posthog]);

    return null;
};
